import { CONTENT_TYPES } from '@uno/common-cms';

var getContentType = function getContentType(contentTypeName) {
  return CONTENT_TYPES[contentTypeName];
};

export default getContentType;